import type {
  ICartItemSchema,
  IStoreCartLineItemSchema
  // ICartSchema
} from '@r/types/zod-schemas.ts';
import type { z } from 'zod';

const totalDynamicPrice = (item: z.infer<typeof ICartItemSchema>) => {
  return (
    item.product.pointUnitPrice *
    ((item.dynamicPriceAmount ?? 1) / (item.product.dynamicQuantity ?? 1))
  );
};

const totalPrice = (item: z.infer<typeof ICartItemSchema>) => {
  return item.product.pointUnitPrice * item.quantity;
};

export const mapCartItemToStoreCartLineItem = (
  item: z.infer<typeof ICartItemSchema>
  // cart: z.infer<typeof ICartSchema>
): z.infer<typeof IStoreCartLineItemSchema> => ({
  // Required fields
  id: String(item.product.id),
  title: item.product.name,
  quantity: item.quantity,
  requires_shipping: false,
  is_discountable: false,
  is_tax_inclusive: false,
  unit_price: item.product.price ?? 0,
  cart_id: 'cart_id',
  added_at: item.addedAt ?? Date.now(),
  // cart: cart,

  item_tax_total: 0,
  original_tax_total: 0,
  tax_total: 0,
  discount_total: 0,
  discount_tax_total: 0,

  item_total: item.product.pointUnitPrice,
  item_subtotal: item.product.pointUnitPrice,

  original_total: item.product.pointUnitPrice,
  original_subtotal: item.product.pointUnitPrice,

  total: item.dynamicPriceAmount ? totalDynamicPrice(item) : totalPrice(item),
  subtotal: item.dynamicPriceAmount ? totalDynamicPrice(item) : totalPrice(item),
  dynamic_price_amount: item.dynamicPriceAmount ?? undefined,

  // Optional fields
  subtitle: undefined,
  thumbnail: item.product.images?.[0]?.pathUri ?? undefined,
  product_iri: item.iri,
  product_id: item.product.id,
  product_title: item.product.name,
  product_description: item.product.description,
  product_subtitle: undefined,
  product_type: undefined,
  product_collection: undefined,
  product_handle: undefined,
  variant_id: undefined,
  variant_sku: undefined,
  variant_barcode: undefined,
  variant_title: undefined,
  variant_option_values: undefined,
  compare_at_unit_price: undefined,
  metadata: item.product.publicMetadatas,

  // Date fields
  created_at: new Date(item.product.createdAt),
  updated_at: undefined,
  deleted_at: undefined,

  // Related entities
  product: item.product,
  variant: undefined,

  // Arrays of related items
  tax_lines: undefined,
  adjustments: undefined
});
